export default __webpack_public_path__ + "static/media/SuraSans-Negrita.b03df955.otf";